import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useReplyCustomerViaEmailPost = () => {
  const { t } = useTranslation();
  const branch = useBranchId();

  const mutation = useMutation({
    mutationFn: ({ message, orderId }: { message: string; orderId: number }) =>
      post2(
        `internal/secure/pos/v1/orders/email/customer/${branch}/${orderId}`,
        { message }
      ),
    onSuccess: () => {
      toast.success(t("success.success"));
    },
  });

  return mutation;
};

export default useReplyCustomerViaEmailPost;
